import React, { useState, useRef, useEffect } from 'react';
import { BsChevronDown, BsChevronUp } from 'react-icons/bs';
import { useDispatch } from 'react-redux';
import { logoutAction } from 'src/redux/action/auth.action';

const DropDown = () => {
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleLogOut = () => {
    dispatch(logoutAction());
  };

  const handleClickOutside = (event: { target: any }) => {
    if (
      dropdownRef.current &&
      !(dropdownRef.current as any).contains(event.target)
    ) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div ref={dropdownRef}>
      {isOpen ? (
        <BsChevronUp onClick={toggleDropdown} />
      ) : (
        <BsChevronDown onClick={toggleDropdown} />
      )}
      {isOpen && (
        <div className="absolute border border-border-color-dark w-[120px] text-center top-[48px] right-10 bg-pure-white z-50 shadow-xl rounded-md py-2 px-4">
          <button className="" onClick={handleLogOut}>
            Log Out
          </button>
        </div>
      )}
    </div>
  );
};

export default DropDown;
